import React, { Component } from 'react';
import EditableCell from '../../basicElement/EditableCell';
import Text from '../../basicElement/Text';
import TableC from '../../basicElement/TableC';

class PeriodTable extends Component {
    getRender = (merge) => {
      return (text, record) => {
            const { colSpan } = record;
            return {
                children: text,
                props: {
                    colSpan: colSpan ? merge ? colSpan : 0 : 1,
                },
            };
        }
    }
    
    getColumns = () => {
        const { data, editable, scoreList } = this.props;
        const len = data.length;
        const columns = [{
            title: '序号',
            dataIndex: 'number',
            key: 'number',
            width: 60,
            render: this.getRender(true),
        }, {
            title: '考核内容',
            dataIndex: 'itemName',
            key: 'itemName',
            width: 200,
            render: this.getRender(false),
        }, {
            title: '分值',
            children: (scoreList || []).map((item, index) => {
                const { detailName } = item;
                return {
                    title: detailName,
                    dataIndex: `detail_${index}`,
                    key: `detail_${index}`,
                    width: 70,
                    render: this.getRender(false),
                }
            })
        }, {
            title: <Text asterisk={editable}>得分</Text>,
            dataIndex: 'score',
            key: 'score',
            width: 100,
            render: (text, record, index) => {
                const { minScore, maxScore } = record;
                if (index < len - 2) {
                    return (
                        <EditableCell
                            type="Number"
                            editable={editable}
                            value={text}
                            config={{ min: minScore, max: maxScore }}
                            onChange={value => this.handleChange(value, index, 'score')}
                        />
                    );
                } else if (index == len - 2) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 2) {
                            total += (item.score || 0) * 1;
                        }
                    });
                    return <strong>{total}</strong>;
                } else {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 2) {
                            total += (item.score || 0) * 1;
                        }
                    });
                    total += (text || 0) * 1;
                    return <strong>{total}</strong>;
                }
            }
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            render: (text, record, index) => {
                if (index < len - 1) {
                    return (
                        <EditableCell type="Input" value={text} editable={editable} onChange={value => this.handleChange(value, index, 'comments')} />
                    );
                }
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.props;
        const target = data[index];
        target[key] = value;
        this.props.onChange(data);
    }

    render() {
        const { data } = this.props;
        return (
            <TableC
                data={data}
                columns={this.getColumns()}
                className="periodTable"
            />
        );
    }
}

export default PeriodTable;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/Component/PeriodTable.js